import { render, staticRenderFns } from "./ProdEditCutChild.vue?vue&type=template&id=4b573d5b&"
import script from "./ProdEditCutChild.vue?vue&type=script&lang=js&"
export * from "./ProdEditCutChild.vue?vue&type=script&lang=js&"
import style0 from "./ProdEditCutChild.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports